import React, { useEffect, useRef, useState } from 'react';
import { getEnvelopeDocumentCheckStorage, modifyEnvelopeDocument, checkMyFilesEnabled } from '../../../../services/CommonService';
import { toast } from 'react-toastify';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import Utils from '../../../../utils';
import { DATE_FORMAT_LIST, EVERY_ONE_OBJECT, ADD_DOCUMENT_DATE_FORMATE_LIST } from '../../../../configs/AppConfig';
import SiteFilesModal from './SiteFilesModal';
import { Tabs, Tab } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Tooltip } from 'bootstrap';
import DocumentPreviewModal from './DocumentPreviewModal';
import mammoth from 'mammoth';
import './PdfUploadPopup.css';


function EnvelopeDocument(props) {
  const [docId, setDocId] = useState(0);
  const [requestFrom, setRequestForm] = useState([]);
  const [docRecipients, setDocRecipients] = useState([]);
  const [docName, setDocName] = useState('');
  const [docDetail, setDocDetail] = useState('');
  const [documentsList, setDocumentsList] = useState([]);
  const [removeDocIds, setRemoveDocIds] = useState([]);
  const [fileKey, setFileKey] = useState(Date.now());
  const [isDateFormat, setIsDateFormat] = useState(false);
  const [dateFormat, setDateFormat] = useState(1);
  const [isDragging, setIsDragging] = useState(false);
  const [isSiteFilesModalOpen, setIsSiteFilesModalOpen] = useState(false);
  const [siteFileLinks, setSiteFileLinks] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [docxPreviewHtml, setDocxPreviewHtml] = useState('');
  const [isDocxLoading, setIsDocxLoading] = useState(false);
  const [isMyFilesEnabled, setIsMyFilesEnabled] = useState(
    typeof props.isMyFilesEnabled === 'boolean' ? props.isMyFilesEnabled : true
  );
  const [activeTab, setActiveTab] = useState("system-files");

  const [errors, setErrors] = useState({
    recipients: '',
    doc_name: '',
    doc_detail: '',
    doc_file: '',
    date_format: '',
  });

  const animatedComponents = makeAnimated();
  const fileInputRef = useRef(null);
  const localFileInputRef = useRef(null);
  const clsButtonRef = useRef(null);

  useEffect(() => {
    // Initialize recipients list when formObj changes
    if (props.formObj) {
      initializeDocRecipients(EVERY_ONE_OBJECT);
    }
  }, [props.formObj]);

  useEffect(() => {
    // Only initialize if we have docData and it's different from current state
    if (props?.docData && !isInitialized) {
      initializeComponentData();
      setIsInitialized(true);
    }
  }, [props?.docData]);

  useEffect(() => {
    // Reset initialization flag when form is closed or when adding new document
    if (!props?.docData) {
      setIsInitialized(false);
      clearDocumentForm();
    }
  }, [props?.docData]);

  useEffect(() => {
    // Initialize all tooltips
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new Tooltip(tooltipTriggerEl);
    });

    // Cleanup tooltips on component unmount
    return () => {
      tooltipTriggerList.map(tooltipTriggerEl => {
        const tooltip = Tooltip.getInstance(tooltipTriggerEl);
        if (tooltip) {
          tooltip.dispose();
        }
        return null;
      });
    };
  }, []);

  useEffect(() => {
    if (typeof props.isMyFilesEnabled === 'boolean') {
      setIsMyFilesEnabled(props.isMyFilesEnabled);
    } else {
      // fallback: fetch if not provided as prop
      checkMyFilesEnabled({})
        .then(res => {
          if (res?.data?.data?.myfiles_enabled === true) {
            setIsMyFilesEnabled(true);
          } else {
            setIsMyFilesEnabled(false);
          }
        })
        .catch(() => setIsMyFilesEnabled(false));
    }
  }, [props.isMyFilesEnabled]);

  useEffect(() => {
    if (!isMyFilesEnabled && activeTab === "local-site-files") {
      setActiveTab("system-files");
    }
  }, [isMyFilesEnabled, activeTab]);

  const initializeComponentData = () => {
    // Clear existing data first but keep recipients list
    clearDocumentForm(true);

    if (props?.docData) {
      setDocId(props.docData.id || 0);
      setDocName(props.docData.doc_name || '');
      setDocDetail(props.docData.doc_detail || '');

      // Ensure documentsList is set only once with proper data
      if (props.docData.documents && documentsList.length === 0) {
        setDocumentsList([...props.docData.documents]);
      }

      if (props.docData.date_format > 0) {
        setIsDateFormat(true);
        setDateFormat(props.docData.date_format);
      }

      initializeRecipients();
    }
  };

  const initializeRecipients = () => {
    let recipientObj = EVERY_ONE_OBJECT;
    let selectedRecipient = [];

    if (props?.docData?.request_id) {
      let recipientIds = props.docData.request_id.split(',');
      let index = recipientIds.findIndex((x) => parseInt(x) === 0);

      if (index > -1) {
        selectedRecipient = [recipientObj];
      } else {
        for (let i = 0; i < recipientIds.length; i++) {
          let index = props.formObj.recipient_List.findIndex(
            (x) => parseInt(x.id) === parseInt(recipientIds[i])
          );
          if (index > -1) {
            selectedRecipient.push({
              value: props.formObj.recipient_List[index]['id'],
              label: props.formObj.recipient_List[index]['first_name'] + ' ' +
                props.formObj.recipient_List[index]['last_name'],
            });
          }
        }
      }
    }

    setRequestForm(selectedRecipient);
  };

  const initializeDocRecipients = (recipientObj) => {
    let recipients = [recipientObj];
    if (props.formObj?.recipient_List) {
      for (let i = 0; i < props.formObj.recipient_List.length; i++) {
        recipients.push({
          value: props.formObj.recipient_List[i]['id'],
          label: props.formObj.recipient_List[i]['first_name'] + ' ' +
            props.formObj.recipient_List[i]['last_name'],
        });
      }
    }
    setDocRecipients(recipients);
  };

  const onDocFile = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      handleFiles(files);
    }
  };

  const handleFiles = (files) => {
    let newFiles = [...documentsList];
    for (let i = 0; i < files.length; i++) {
      // Check if file already exists
      const fileExists = newFiles.some(
        (item) => item.name === files[i].name && item.size === files[i].size
      );

      if (!fileExists) {
        let kb = files[i].size / 1000;
        newFiles.push({
          id: 0,
          name: files[i].name,
          kb: parseFloat(kb).toFixed(2),
          file: files[i],
        });
      }
    }
    setDocumentsList(newFiles);
    setFileKey(Date.now());
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      handleFiles(files);
    }
  };

  const onRemoveDoc = (e, obj) => {
    e.preventDefault();
    setDocumentsList((current) => current.filter((doc) => doc.id !== obj.id || doc.name !== obj.name));

    if (obj.id > 0) {
      setRemoveDocIds((prev) => [...prev, obj.id]);
    }
  };

  const onCloseDocument = (e) => {
    e.preventDefault();
    clsButtonRef.current?.click();
    clearDocumentForm();
    setIsInitialized(false);
  };

  const clearDocumentForm = (keepRecipients = false) => {
    setDocId(0);
    if (!keepRecipients) {
      setRequestForm([]);
    }
    setDocName('');
    setDocDetail('');
    setDocumentsList([]);
    setIsDateFormat(false);
    setDateFormat(0);
    setIsDragging(false);
    setRemoveDocIds([]);
    setSiteFileLinks([]);
    setErrors({
      recipients: '',
      doc_name: '',
      doc_detail: '',
      doc_file: '',
      date_format: '',
    });
    setFileKey(Date.now());
  };

  const onSaveAddDoc = (e) => {
    e.preventDefault();
    onStoreDoc(e, 2);
  };

  const onSaveDoc = (e) => {
    e.preventDefault();
    onStoreDoc(e, 1);
  };

  const onStoreDoc = async (e, type) => {
    e.preventDefault();

    if (!validateForm()) return;

    props.setLoading(true);
    const recipientIds = getRecipientIds();
    const formData = prepareFormData(recipientIds);

    const totalKb = calculateTotalFileSize();
    if (totalKb > 0 && !(await checkStorage(totalKb))) {
      props.setLoading(false);
      return;
    }

    try {
      const response = await modifyEnvelopeDocument(formData);

      if (type === 1) {
        clsButtonRef.current?.click();
      }

      clearDocumentForm();
      setIsInitialized(false);

      updateParentState(response.data.id, recipientIds);
      toast.success(response.data.message);
    } catch (err) {
      toast.error(Utils.getErrorMessage(err));
    } finally {
      props.setLoading(false);
    }
  };

  const validateForm = () => {
    let error = false;
    const errorObj = { ...errors };

    if (requestFrom.length === 0) {
      errorObj.recipients = 'Please select request from';
      error = true;
    }
    if (!docName) {
      errorObj.doc_name = 'Document name must be required';
      error = true;
    }

    if (documentsList.length > 10) {
      toast.error('Maximum 10 file upload');
      error = true;
    } else if (documentsList.length > 0) {
      const totalKb = calculateTotalFileSize();
      if (totalKb > 0) {
        const totalMb = totalKb / 1000;
        if (totalMb > 20) {
          toast.error('Maximum 20 MB file allowed');
          error = true;
        }
      }
    }

    // if (isDateFormat && parseInt(dateFormat) === 0) {
    //     errorObj.date_format = 'Please select option';
    //     error = true;
    // }

    setErrors(errorObj);

    if (error) {
      let errorMessages = [];

      Object.keys(errorObj).forEach(key => {
        if (errorObj[key]) {
          errorMessages.push(errorObj[key]);
        }
      });

      if (errorMessages.length > 0) {
        if (errorMessages.length === 1) {
          toast.error(errorMessages[0]);
        } else {
          toast.error(errorMessages.join(" and "));
        }
      }

      return false;
    }

    return true;
  };

  const calculateTotalFileSize = () => {
    return documentsList.reduce((total, doc) => total + parseFloat(doc.kb), 0);
  };

  const getRecipientIds = () => {
    let recipientIds = '';
    for (let i = 0; i < requestFrom.length; i++) {
      if (parseInt(requestFrom[i]['value']) === 0) {
        return '0';
      } else {
        recipientIds += requestFrom[i]['value'];
        if (requestFrom.length !== i + 1) {
          recipientIds += ',';
        }
      }
    }
    return recipientIds;
  };

  const prepareFormData = (recipientIds) => {
    const formData = new FormData();
    formData.append('envelope_id', props.formObj.envelope_id);
    formData.append('doc_id', docId);
    formData.append('request_form', recipientIds);
    formData.append('name', docName);
    formData.append('detail', docDetail);
    formData.append('date_format', dateFormat);

    // Add the site file links if any
    if (siteFileLinks.length > 0) {
      formData.append('doc_link', JSON.stringify(siteFileLinks));
    }

    // Add uploaded files
    documentsList.forEach((doc) => {
      if (doc.file) { // Only append actual File objects
        formData.append('doc_file', doc.file);
      }
    });

    if (removeDocIds.length > 0) {
      formData.append('remove_doc_id', JSON.stringify(removeDocIds));
    }

    return formData;
  };

  const checkStorage = async (totalKb) => {
    try {
      const res = await getEnvelopeDocumentCheckStorage({ kb: totalKb });
      if (res.data.is_storage_full) {
        toast.error(res.data.message);
        return false;
      }
      return true;
    } catch (err) {
      toast.error(Utils.getErrorMessage(err));
      return false;
    }
  };

  const updateParentState = (newDocId, recipientIds) => {
    const envelopeFormData = { ...props.formObj };
    const requestDisplay = getRequestDisplay(recipientIds, envelopeFormData);

    if (docId > 0) {
      const index = envelopeFormData.documents.findIndex((x) => parseInt(x.id) === parseInt(docId));
      if (index > -1) {
        envelopeFormData.documents[index] = {
          ...envelopeFormData.documents[index],
          name: docName,
          request_id: recipientIds,
          request_display: requestDisplay,
          doc_detail: docDetail,
          documents: documentsList,
          date_format: dateFormat,
        };
      }
    } else {
      envelopeFormData.documents.push({
        id: newDocId,
        name: docName,
        request_id: recipientIds,
        request_display: requestDisplay,
        doc_detail: docDetail,
        documents: documentsList,
        date_format: dateFormat,
      });
    }

    props.setFormObj(envelopeFormData);
  };

  const getRequestDisplay = (recipientIds, envelopeFormData) => {
    if (recipientIds === '0') return [];

    return recipientIds.split(',').map((id) => {
      const recipient = envelopeFormData.recipient_List.find((x) => parseInt(x.id) === parseInt(id));
      if (!recipient) return null;

      return {
        full_name: `${recipient.first_name} ${recipient.last_name}`,
        display: `${recipient.first_name.charAt(0)}${recipient.last_name.charAt(0)}`,
      };
    }).filter(Boolean);
  };

  const handleDownload = async (e, obj) => {
    e.preventDefault();
    props.setLoading(true);
    await Utils.downloadAnyFile(obj.path, obj.name);
    props.setLoading(false);
  };

  const handleRequestRecipient = (options) => {
    const checkEveryone = options.findIndex((x) => parseFloat(x.value) === 0);
    setRequestForm(checkEveryone > -1 ? [EVERY_ONE_OBJECT] : options);
  };

  const handleDateFormat = (e) => {
    setIsDateFormat(e.target.checked);
    setDateFormat(1);
  };

  const handleSelectSiteFiles = (selectedFiles) => {
    // Store the links separately
    const links = selectedFiles.map(file => file.file_path);
    setSiteFileLinks(links);

    // Add to documents list for display
    const newFiles = selectedFiles.map((file) => ({
      id: 0,
      name: file.file_name,
      kb: file.size ? parseFloat(file.size.split(' ')[0]) * (file.size.includes('MB') ? 1000 : 1) : 0,
      file: null,
      path: file.file_path,
    }));

    setDocumentsList([...documentsList, ...newFiles]);
    setIsSiteFilesModalOpen(false);
  };

  const handleLocalSiteFilesClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsSiteFilesModalOpen(true);
  };

  // Helper to get file extension
  const getFileExtension = (name) => {
    if (!name) return '';
    return name.split('.').pop().toLowerCase();
  };

  // Handler for preview click
  const handlePreviewFile = async (file) => {
    setDocxPreviewHtml('');
    setIsDocxLoading(false);
    setPreviewFile(file);
    setIsPreviewModalOpen(true);
    // Only for docx and only in edit mode
    if (docId > 0 && getFileExtension(file.name) === 'docx' && (file.path || file.file_path)) {
      setIsDocxLoading(true);
      try {
        const url = file.path || file.file_path;
        const response = await fetch(url);
        if (!response.ok) throw new Error('Failed to fetch .docx file');
        const arrayBuffer = await response.arrayBuffer();
        const result = await mammoth.convertToHtml({ arrayBuffer });
        setDocxPreviewHtml(result.value);
      } catch (err) {
        setDocxPreviewHtml('<div style="color:red">Failed to load .docx preview</div>');
      } finally {
        setIsDocxLoading(false);
      }
    }
  };

  // Helper to get preview URL
  const getPreviewUrl = (file) => {
    // For backend/site files
    if (file.path) return file.path;
    if (file.file_path) return file.file_path;
    // For local uploads (no preview)
    return null;
  };

  return (

    <div className="offcanvas offcanvas-end modern-upload-panel" data-bs-scroll="false" tabIndex={-1}
      data-bs-keyboard="true" data-bs-backdrop="static" id="Add-document" aria-labelledby="Add-documentLabel">
      <div className="offcanvas-header modern-header">
        <h5 className="offcanvas-title modern-title" id="Add-documentLabel">
          {docId > 0 ? 'Edit Document' : 'Add Document'}
        </h5>
        <button
          type="button"
          ref={clsButtonRef}
          onClick={onCloseDocument}
          className="btn btn-close modern-close-btn"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          <i className="bi bi-x-circle" aria-hidden="true" />
        </button>
      </div>
      <div className="offcanvas-body modern-body p-0" style={{ overflowX: "hidden" }}>
        <div className="modern-container">
          <div className="modern-document-details-card">
            <div className="modern-card-header">
              <label htmlFor="request_from" className="modern-label">
                <i className="bi bi-people me-2"></i>
                Document Request from*
                <i class="bi bi-info-circle-fill ms-1 cur-pointer" data-bs-toggle="tooltip" data-bs-placement="right" aria-label="Select who should provide this document" data-bs-original-title="Select who should provide this document"></i>
              </label>
            </div>
            <div className="modern-form-group">
              <Select
                closeMenuOnSelect={true}
                value={requestFrom}
                components={animatedComponents}
                isMulti
                onChange={handleRequestRecipient}
                options={docRecipients}
                placeholder="Select recipients"
                required
              />
              {errors.recipients && <div className="modern-error-text">{errors.recipients}</div>}
            </div>
          </div>

          <div className="modern-document-details-card">
            <div className="modern-card-header">
              <label htmlFor="document_name" className="modern-label">
                <i className="bi bi-file-text me-2"></i>
                Document Details
              </label>
            </div>
            <div className="modern-form-group">
              <div className="modern-input-wrapper">
                {/* <label htmlFor="document_name" className="modern-label w-100 text-black fs-5 mb-2">
                  Document Name*
                </label> */}
                <input
                  type="text"
                  className={`modern-input ${errors.doc_name ? "modern-input-error" : ""}`}
                  id="document_name"
                  value={docName}
                  onChange={(e) => setDocName(e.target.value)}
                  aria-describedby="emailHelp"
                  placeholder="Enter Document Name*"
                />
                <i
                  className="bi bi-info-circle-fill modern-info-icon"
                  aria-hidden="true"
                  data-toggle="tooltip"
                  data-placement="right"
                  aria-label="Enter a name for the documents being requested"
                  data-bs-original-title="Enter a name for the documents being requested"
                />
              </div>
              {errors.doc_name && <div className="modern-error-text">{errors.doc_name}</div>}
            </div>
            <div className="modern-form-group">
              <div className="modern-input-wrapper">
                <textarea
                  className={`modern-textarea ${errors.doc_detail ? "modern-input-error" : ""}`}
                  id="document_detail"
                  rows="3"
                  value={docDetail}
                  onChange={(e) => setDocDetail(e.target.value)}
                  placeholder="Enter Document Description"
                />
                <i
                  className="bi bi-info-circle-fill modern-info-icon"
                  aria-hidden="true"
                  data-toggle="tooltip"
                  data-placement="right"
                  aria-label="Provide a brief description of the documents being requested"
                  data-bs-original-title="Provide a brief description of the documents being requested"
                />
              </div>
              {errors.doc_detail && <div className="modern-error-text">{errors.doc_detail}</div>}
            </div>
          </div>

          {/* <div className="card mb-4 rounded add_document mx-3" id="additional_field">
                    <div className="row"> */}
          {/* <div className="mb-2 d-flex align-items-center">
                            <input
                                className="form-check-input mt-0"
                                checked={isDateFormat}
                                onChange={handleDateFormat}
                                type="checkbox"
                                id="expiry_date"
                            />
                            <label className="form-label ms-2 mt-0 mb-0" htmlFor="expiry_date">
                                Add Expiry Date
                            </label>
                            <i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer"
                                data-bs-toggle="tooltip"
                                data-bs-placement="right"
                                title="Recipients will enter the expiry date for this document" />
                        </div> */}
          {/* {isDateFormat && (
                            <div className="mb-3">
                                <select
                                    className="form-select"
                                    value={dateFormat}
                                    onChange={(e) => setDateFormat(e.target.value)}
                                >
                                    <option value={0}>Select date format</option>
                                    {DATE_FORMAT_LIST.map((item, index) => (
                                        <option value={item.id} key={index}>
                                            {item.text}
                                        </option>
                                    ))}
                                </select>
                                {errors.date_format && <div className="text-danger">{errors.date_format}</div>}
                            </div>
                        )} */}
          {/* {isDateFormat && (
                            <div className="mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    value="dd/mm/yyyy"
                                    readOnly
                                    placeholder="Date format"
                                />
                                {errors.date_format && <div className="text-danger">{errors.date_format}</div>}
                            </div>
                        )}
                    </div>
                </div> */}

          <div className="modern-upload-section">
            <div className="modern-upload-header">
              <label className="modern-label">
                <i className="bi bi-cloud-upload me-2"></i>
                Upload Documents
              </label>
              <i className="bi bi-info-circle-fill ms-2" aria-hidden="true" data-toggle="tooltip" data-placement="right" aria-label="Upload documents to send to your clients" data-bs-original-title={isMyFilesEnabled ? "Choose to upload from your computer or select from files already stored on docusafe my files." : "Choose to upload from your computer."} />
            </div>
            <div className="modern-upload-container">
              <div className="modern-file-list">

              </div>
              <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} id="file-upload-tabs" className="drb-custom-tabs gap-4">
                <Tab eventKey="system-files" title={<><i className="bi bi-cloud-arrow-up me-2 border-right border-2" />System Files</>}>
                  {documentsList.length > 0 ? (
                    documentsList.map((item, index) => (
                      <div key={index} className="modern-file-item">
                        <div className="modern-file-info">
                          <i className="bi bi-file-earmark-pdf modern-file-icon"></i>
                          <span
                            className="modern-file-name"
                            style={{ cursor: getPreviewUrl(item) ? 'pointer' : 'not-allowed' }}
                            onClick={() => getPreviewUrl(item) && handlePreviewFile(item)}
                            title={getPreviewUrl(item) ? 'Preview' : 'No preview available'}
                          >
                            {item.name}
                          </span>
                        </div>
                        <button
                          onClick={(event) => onRemoveDoc(event, item)}
                          className="modern-remove-btn"
                          title="Remove file"
                        >
                          <i className="bi bi-x-circle-fill" aria-hidden="true" />
                        </button>
                      </div>
                    ))
                  ) : (
                    <div className="modern-no-files">
                      <i className="bi bi-inbox text-muted"></i>
                      <span className="text-muted">No files selected</span>
                    </div>
                  )}
                  <div
                    className={`modern-drag-area ${isDragging ? 'modern-dragging' : ''}`}
                    onDragOver={handleDragOver}
                    onDragEnter={handleDragEnter}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    onClick={() => fileInputRef.current?.click()}
                  >
                    <div className="modern-upload-icon">
                      <i className="bi bi-cloud-arrow-up" aria-hidden="true" />
                    </div>
                    <h5 className="modern-upload-title">Upload from your computer</h5>
                    <p className="modern-upload-description">
                      Drag & drop files here, or click to browse and select files from your device.
                    </p>
                    <div className="modern-upload-hint">
                      <i className="bi bi-file-earmark-pdf me-1"></i>
                      Maximum file size: 20MB
                    </div>
                    <input
                      type="file"
                      ref={fileInputRef}
                      key={fileKey}
                      id="document_file"
                      onChange={onDocFile}
                      multiple
                      className="d-none"
                    />
                  </div>
                </Tab>
                {isMyFilesEnabled && (
                  <Tab eventKey="local-site-files" title={<><i className="bi bi-folder me-2" />Docusafe My Files</>}>
                    {documentsList.length > 0 ? (
                      documentsList.map((item, index) => (
                        <div key={index} className="modern-file-item">
                          <div className="modern-file-info">
                            <i className="bi bi-file-earmark-pdf modern-file-icon"></i>
                            <span
                              className="modern-file-name"
                              style={{ cursor: getPreviewUrl(item) ? 'pointer' : 'not-allowed' }}
                              onClick={() => getPreviewUrl(item) && handlePreviewFile(item)}
                              title={getPreviewUrl(item) ? 'Preview' : 'No preview available'}
                            >
                              {item.name}
                            </span>
                          </div>
                          <button
                            onClick={(event) => onRemoveDoc(event, item)}
                            className="modern-remove-btn"
                            title="Remove file"
                          >
                            <i className="bi bi-x-circle-fill" aria-hidden="true" />
                          </button>
                        </div>
                      ))
                    ) : (
                      <div className="modern-no-files">
                        <i className="bi bi-inbox text-muted"></i>
                        <span className="text-muted">No files selected</span>
                      </div>
                    )}
                    <div
                      className={`modern-drag-area ${isDragging ? 'modern-dragging' : ''}`}
                      onDragOver={handleDragOver}
                      onDragEnter={handleDragEnter}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      onClick={handleLocalSiteFilesClick}
                    >
                      <div className="modern-upload-icon">
                        <i className="bi bi-folder" aria-hidden="true" />
                      </div>
                      <h5 className="modern-upload-title">Select from Docusafe My Files</h5>
                      <p className="modern-upload-description">
                        Click to browse and select files that are already uploaded to Docusafe My Files.
                      </p>
                      <div className="modern-upload-hint">
                        <i className="bi bi-folder2-open me-1"></i>
                        Browse your uploaded files
                      </div>
                      <input
                        type="file"
                        ref={localFileInputRef}
                        key={fileKey}
                        id="local_document_file"
                        onChange={onDocFile}
                        multiple
                        className="d-none"
                      />
                    </div>
                  </Tab>
                )}
              </Tabs>
              {errors.doc_file && <div className="modern-error-text">{errors.doc_file}</div>}
            </div>
          </div>
        </div>

        <div className="modern-footer">
          <button
            type="button"
            ref={clsButtonRef}
            data-bs-dismiss="offcanvas"
            onClick={onCloseDocument}
            className="btn-back-outline"
          >
            {/* <i className="bi bi-x-circle me-2"></i> */}
            Cancel
          </button>
          {docId === 0 && (
            <button type="button" onClick={onSaveAddDoc} className="btn btn-save-outline">
              {/* <i className="bi bi-plus-circle me-2"></i> */}
              Save & Add Another
            </button>
          )}
          <button
            type="button"
            onClick={onSaveDoc}
            className="btn btn-save"
            disabled={props.loading}
          >
            {props.loading ? (
              <>
                {/* <i className="bi bi-hourglass-split me-2"></i> */}
                Saving...
              </>
            ) : (
              <>
                {/* <i className="bi bi-check-circle me-2"></i> */}
                Save
              </>
            )}
          </button>
        </div>
      </div>

      {isSiteFilesModalOpen && (
        <SiteFilesModal
          show={isSiteFilesModalOpen}
          handleClose={() => setIsSiteFilesModalOpen(false)}
          onSelectFiles={handleSelectSiteFiles}
        />
      )
      }
      {
        isPreviewModalOpen && (
          <DocumentPreviewModal
            show={isPreviewModalOpen}
            onClose={() => setIsPreviewModalOpen(false)}
            title={previewFile?.name || 'File Preview'}
          >
            {(() => {
              const url = getPreviewUrl(previewFile);
              const ext = getFileExtension(previewFile?.name);
              if (!url) {
                return <div className="text-center">Preview not available for this file.</div>;
              }
              if (["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(ext)) {
                return <img src={url} alt={previewFile?.name} style={{ maxWidth: '100%', maxHeight: '80vh' }} />;
              }
              if (ext === "pdf") {
                return <iframe src={url} style={{ width: '100%', height: '80vh', border: 'none' }} />;
              }
              if (ext === "docx") {
                if (isDocxLoading) {
                  return <div className="text-center">Loading DOCX preview...</div>;
                }
                return <div className="docx-preview p-3 bg-light rounded-3" style={{ maxHeight: '80vh', overflowY: 'auto' }} dangerouslySetInnerHTML={{ __html: docxPreviewHtml }} />;
              }
              // For other files, show download link
              return <div className="text-center">
                <a href={url} target="_blank" rel="noopener noreferrer" className="btn btn-primary">Download & View</a>
                <div className="mt-2">Preview not supported for this file type.</div>
              </div>;
            })()}
          </DocumentPreviewModal>
        )
      }
    </div >
  );
}

export default EnvelopeDocument;